import {clsx} from 'clsx';
import {isContainerQueryAvailable} from '../lib/container-query-with-fallback';
import styles from './media-user-login-link.module.css';

type Props = {
  readonly companyId: number;
  readonly releaseId: number;
  /** ログイン後にリダイレクトする URL */
  readonly redirectBackPath: string;
};

export function MediaUserLoginLink({
  companyId,
  releaseId,
  redirectBackPath,
  ...props
}: Props) {
  return (
    <div className={styles.container} {...props}>
      <a
        href={`/main/action.php?run=html&page=medialogin&company_id=${companyId}&release_id=${releaseId}&message=releasemediaonly&uri=${encodeURIComponent(
          redirectBackPath,
        )}`}
        className={clsx(
          styles.link,
          isContainerQueryAvailable() ? styles.linkCQ : styles.linkFallback,
        )}
      >
        メディアユーザーログイン
      </a>
      <span
        className={clsx(
          styles.text,
          isContainerQueryAvailable() ? styles.textCQ : styles.textFallback,
        )}
      >
        既に登録済みの方はこちら
      </span>
    </div>
  );
}
